import { TriangleAlert } from 'lucide-react';

import { ErroApi } from '@/lib/api';

/**
 * Falha ao montar um bloco.
 *
 * Um relatório em branco é indistinguível de um relatório sem dados — e as
 * duas coisas levam o gestor a conclusões opostas. Por isso a falha é dita com
 * todas as letras, em vez de virar silêncio.
 */
export function ErroBloco({ erro }: { erro: unknown }) {
  const mensagem =
    erro instanceof ErroApi ? erro.mensagemUsuario : 'Não foi possível carregar o relatório.';

  return (
    <div className="border-status-devolvido-borda bg-status-devolvido-fundo text-status-devolvido-texto flex items-start gap-3 rounded-xl border p-4 text-sm">
      <TriangleAlert className="mt-0.5 size-5 shrink-0" aria-hidden="true" />
      <div>
        <p className="font-medium">Não foi possível carregar este bloco.</p>
        <p>{mensagem}</p>
      </div>
    </div>
  );
}
